'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: ', ';\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  border: 0px solid transparent;\n  box-sizing: border-box;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  box-sizing: border-box;\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  border: 0px solid transparent;\n  box-sizing: border-box;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  box-sizing: border-box;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  margin-top: 15px;\n  border: 2px solid ', '};\n  border-radius: 10px;\n  ', ';\n  ', ';\n  cursor: pointer;\n'], ['\n  position: relative;\n  margin-top: 15px;\n  border: 2px solid ', '};\n  border-radius: 10px;\n  ', ';\n  ', ';\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  justify-content: center;\n  height: 5vh;\n  cursor: pointer;\n'], ['\n  justify-content: center;\n  height: 5vh;\n  cursor: pointer;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 15px;\n  padding-right: 15px;\n  cursor: pointer;\n'], ['\n  padding-left: 15px;\n  padding-right: 15px;\n  cursor: pointer;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    margin-left: 15px;\n    margin-right: 15px;\n    cursor: pointer;\n'], ['\n    margin-left: 15px;\n    margin-right: 15px;\n    cursor: pointer;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: flex-start;\n  margin: auto;\n  cursor: pointer;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: flex-start;\n  margin: auto;\n  cursor: pointer;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 2px;\n  right: 4px;\n'], ['\n  position: absolute;\n  top: 2px;\n  right: 4px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  fill: none;\n  stroke: white;\n  stroke-width: 2px;\n'], ['\n  fill: none;\n  stroke: white;\n  stroke-width: 2px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n'], ['\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n\n  ', '\n\n  ', ':focus + & {\n    box-shadow: 0 0 0 3px pink;\n  }\n\n  ', ' {\n    visibility: ', '\n  }\n'], ['\n\n  ', '\n\n  ', ':focus + & {\n    box-shadow: 0 0 0 3px pink;\n  }\n\n  ', ' {\n    visibility: ', '\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactSvg = require('react-svg');

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MainContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var inline = _ref.inline;
    return inline ? 'row' : 'column';
}, function (_ref2) {
    var fullSize = _ref2.fullSize;
    return fullSize && 'min-height: 100%; min-width: 100%;';
}, function (_ref3) {
    var fullWidth = _ref3.fullWidth;
    return fullWidth && 'min-width: 100%;';
}, function (_ref4) {
    var fullHeight = _ref4.fullHeight;
    return fullHeight && 'min-height: 100%;';
}, function (_ref5) {
    var color = _ref5.color;
    return color && 'background-color: ' + color + ';';
}, function (_ref6) {
    var top = _ref6.top;
    return 'margin-top: ' + top + 'px;';
}, function (_ref7) {
    var bottom = _ref7.bottom;
    return 'margin-bottom: ' + bottom + 'px;';
}, function (_ref8) {
    var left = _ref8.left;
    return 'margin-left: ' + left + 'px;';
}, function (_ref9) {
    var right = _ref9.right;
    return 'margin-right: ' + right + 'px;';
});

var ChecklistButton = (0, _styledComponents2.default)(_metrixCommon.Column)(_templateObject2, function (_ref10) {
    var selected = _ref10.selected;
    return selected ? _metrixCommon.Colors.Primary : _metrixCommon.Colors.StrokeLight;
}, function (_ref11) {
    var isMobile = _ref11.isMobile;
    return isMobile && 'margin-bottom: inherit';
}, function (_ref12) {
    var isTablet = _ref12.isTablet;
    return isTablet && 'margin-left: 0px;';
});

var TitleRow = (0, _styledComponents2.default)(_metrixCommon.Row)(_templateObject3);

var TitleHeader = (0, _styledComponents2.default)(_metrixCommon.Header)(_templateObject4);

var Description = (0, _styledComponents2.default)(_metrixCommon.Label)(_templateObject5);

var InsideButton = _styledComponents2.default.div(_templateObject6);

var CheckboxContainer = _styledComponents2.default.div(_templateObject7);

var CheckBoxIcon = _styledComponents2.default.svg(_templateObject8);

var HiddenCheckbox = _styledComponents2.default.input.attrs({ type: 'checkbox' })(_templateObject9);

var StyledCheckbox = _styledComponents2.default.div(_templateObject10, function (_ref13) {
    var checked = _ref13.checked;
    return checked && '\n      display: inline-block;\n      width: 25px;\n      height: 25px;\n      margin-top: 4px;\n      margin-right: 0px;\n      background: ' + _metrixCommon.Colors.Primary + ';\n      border-radius: 3px;\n  ';
}, HiddenCheckbox, CheckBoxIcon, function (_ref14) {
    var checked = _ref14.checked;
    return checked ? 'visible' : 'hidden';
});

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component(props) {
        _classCallCheck(this, Component);

        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, props));

        _this.selectedVar = '';

        _this.handleReturn = function (value) {

            var labelElements = [];
            var returnElements = _this.props.return ? _this.props.return.elements : [];
            labelElements = [{
                code: "Label",
                value: '' + value.elements[1].value
            }];
            var selectedValues = returnElements.filter(function (x) {
                return x.value === value.code;
            }) || [];

            if (selectedValues.length > 0) {
                selectedValues = returnElements.filter(function (x) {
                    return x.value != value.code;
                }) || [];
            } else {
                returnElements.push({
                    code: "Value",
                    value: '' + value.code,
                    elements: labelElements
                });
                selectedValues = returnElements;
            }

            // setting return object
            _this.props.doSetReturn({
                componentCode: _this.props.component.code,
                code: null,
                value: selectedValues
            });
        };

        return _this;
    }

    // store index of selected list


    _createClass(Component, [{
        key: 'handleCheckBox',


        // invoke when checkbox is clicked and set or append selected index to selectedVar
        value: function handleCheckBox(e, ele, inReturn) {
            if (!this.selectedVar.includes('' + ele) && !inReturn) {
                this.selectedVar = this.selectedVar + ('' + ele);
            } else {
                this.selectedVar = this.selectedVar.replace('' + ele, '');
            }

            return null;
        }

        // invoke when checkbox is clicked and set return object

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isMobile = this.context.screen.isMobile;
            var isTablet = this.context.screen.isTablet;
            var options = (0, _metrixCommon.getElementsByCode)(this.props.component.elements, 'Options');

            return _react2.default.createElement(
                MainContainer,
                { fullsize: true, inline: !isMobile, top: isMobile ? (0, _metrixCommon.getSize)(_metrixCommon.Sizes.md) : (0, _metrixCommon.getSize)(_metrixCommon.Sizes.xs), bottom: isMobile ? (0, _metrixCommon.getSize)(_metrixCommon.Sizes.lg) : (0, _metrixCommon.getSize)(_metrixCommon.Sizes.md) },
                options && options.map(function (option, i) {

                    // fixed formate of object which is stored in reference
                    var opt = option.elements;
                    var img = opt[0];
                    var title = opt[1];
                    var desc = opt[2];

                    // get return value and check which values are selected
                    var savedValues = _this2.props.return || [];
                    if (savedValues.hasOwnProperty("elements")) {
                        savedValues = savedValues.elements.map(function (x) {
                            return x.value;
                        });
                    }
                    var inReturn = savedValues.includes(option.code);
                    var check = inReturn || _this2.selectedVar.includes('' + i) ? true : false;

                    var button = null;

                    button = _react2.default.createElement(
                        ChecklistButton,
                        { md: isTablet ? 6 : 5, isMobile: isMobile, isTablet: isTablet, selected: check },
                        _react2.default.createElement(
                            InsideButton,
                            { id: 'Select' + i, onClick: function onClick(e) {
                                    _this2.handleCheckBox(e, '' + i, inReturn);_this2.handleReturn(option);
                                } },
                            isMobile && _react2.default.createElement(
                                CheckboxContainer,
                                null,
                                _react2.default.createElement(HiddenCheckbox, { id: 'Select' + i, checked: check }),
                                _react2.default.createElement(
                                    StyledCheckbox,
                                    { checked: check },
                                    _react2.default.createElement(
                                        CheckBoxIcon,
                                        { viewBox: '0 0 24 24' },
                                        _react2.default.createElement('polyline', { points: '20 6 9 17 4 12' })
                                    )
                                )
                            ),
                            _react2.default.createElement(_reactSvg.ReactSVG, {
                                afterInjection: function afterInjection(error) {
                                    if (error) {
                                        console.log("Error inside Workflow: ", error);
                                    };
                                },
                                beforeInjection: function beforeInjection(svg) {
                                    check ? svg.setAttribute('fill', '' + _metrixCommon.Colors.Primary) : svg.setAttribute('fill', '' + _metrixCommon.Colors.DarkMode);
                                    svg.setAttribute('style', 'width: 127px; height: 152px; margin-top: 20px; ' + (isTablet ? 'margin-top: 20px;' : ''));
                                },
                                src: process.env.PUBLIC_URL + '/assets/iconList/' + img.value + '.svg' }),
                            !isMobile && _react2.default.createElement(
                                CheckboxContainer,
                                null,
                                _react2.default.createElement(HiddenCheckbox, { id: 'Select' + i, checked: check }),
                                _react2.default.createElement(
                                    StyledCheckbox,
                                    { checked: check },
                                    _react2.default.createElement(
                                        CheckBoxIcon,
                                        { viewBox: '0 0 24 24' },
                                        _react2.default.createElement('polyline', { points: '20 6 9 17 4 12' })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                TitleRow,
                                { isTablet: isTablet },
                                _react2.default.createElement(TitleHeader, { size: _metrixCommon.Sizes.xs,
                                    color: _metrixCommon.Colors.PrimaryText,
                                    text: '' + title.value,
                                    textAlign: _metrixCommon.Alignments.center,
                                    bold: true })
                            ),
                            _react2.default.createElement(
                                _metrixCommon.Row,
                                null,
                                _react2.default.createElement(Description, { color: _metrixCommon.Colors.PrimaryText, text: desc.value })
                            )
                        )
                    );

                    return button;
                })
            );
        }
    }]);

    return Component;
}(_react2.default.Component);

Component.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = Component;